import { ReactNode, useMemo } from 'react';
import { IFilterSet, IFiltersComponentsMap } from 'shared/types/filters';
import { useSelector } from 'react-redux';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';

interface IAvailableFilter<T> {
  id: T;
  component: ReactNode;
}

interface IParams<T extends string> {
  filtersSet: IFilterSet<T>[];
  filtersComponentsMap: IFiltersComponentsMap;
}

export function useAvailableFilters<T extends string>({
  filtersSet,
  filtersComponentsMap,
}: IParams<T>): IAvailableFilter<T>[] {
  const jsonQuery = useSelector(selectJsonQuery);

  return useMemo(() => {
    const availableFilterKeys = filtersSet.find(filter => filter.availability(jsonQuery))?.list || [];

    return availableFilterKeys.map(filterKey => {
      const FilterComponent = filtersComponentsMap[filterKey];

      return { id: filterKey, component: <FilterComponent /> };
    });
  }, [filtersComponentsMap, filtersSet, jsonQuery]);
}
